import axios from "axios";
import store from "@/store";
import { appEnv } from "./helper";
import { getApiKey } from "@/api/notificationApiKey";

let notifyToken;
let baseURL = import.meta.env.VITE_NOTIFICATION_PROCESSOR_URL;

if (appEnv.isTest || appEnv.isDevelopment) {
  baseURL = import.meta.env.VITE_TEST_NOTIFICATION_PROCESSOR_URL;
}

let fcmToken;

export const setFcmUserToken = async (token) => {
  fcmToken = token;
  try {
    notifyToken = await getApiKey();
    await axios.post(
      `${baseURL}/api/app/fcm-user-token`,
      {
        token: fcmToken,
        userId: store.state.auth.user.id,
        platformType: 1,
      },
      {
        headers: {
          "nozzle-apikey": notifyToken,
          "Content-Type": "application/json",
        },
        withCredentials: false,
      }
    );
    console.log('FCM token registered successfully');
  } catch (error) {
    console.error("Error setting FCM token:", error);
  }
};

export const removeFcmUserToken = async () => {
  try {
    await axios.delete(`${baseURL}/api/app/fcm-user-token?Token=${fcmToken}`, {
      headers: {
        "nozzle-apikey": notifyToken,
      },
    });
    console.log('FCM token removed successfully');
  } catch (error) {
    console.error("Error removing FCM token:", error);
  }
};
